<lm-form-content-form
    #LMFormContentForm
    *ngIf="formSpec"
    [formSpec]="formSpec"
    [formOptions]="formOptions"
    [specFields]="specFields"
    [placeHolder]="placeHolder"
    [layout]="layout"
    [model]="model"
    (keyup.enter)="onSearchClicked($event)"
    (fieldEvent)="onFieldEvent($event)"
></lm-form-content-form>
<!--(focusout)="onSearchClicked($event)"-->
<ng-container *ngIf="!isCodeBlockFilter">
  <div class="lm-search-button-container">
    <span *ngIf="columnarText !== undefined" class="span-columnar-text" title="{{columnarText}}">{{columnarText}}</span>

    <!--
    Annoying but we need 'btn-tertiary' to appear first
    in the class list so that some sohoxi css rules will work
    -->
    <button id="{{searchButtonId}}" soho-button="tertiary" class="btn-tertiary lm-run-search-button" (click)="onSearchClicked($event)">{{searchTitle}}</button>
    <button id="{{clearButtonId}}" soho-button="tertiary" class="btn-tertiary lm-clear-search-button" (click)="onClearSearchClicked($event)">{{clearTitle}}</button>
  </div>
</ng-container>
